import WithdrawPage from './WithdrawPage';

export default WithdrawPage;
